import type { ReactElement } from 'react';
import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function Check({
  innerColor,
  backgroundColor = 'transparent',
  ...props
}: IconSvgProps): ReactElement {
  return (
    <BaseLibraryIconSvg {...props}>
      <rect
        x='1.66602'
        y='22.5'
        width='21'
        height='21'
        rx='10.5'
        transform='rotate(-90 1.66602 22.5)'
        fill={backgroundColor ? backgroundColor : 'currentColor'}
        strokeWidth='2'
        stroke='currentColor'
      />
      <path
        d='M17.1475 8.96002L10.3774 15.7301L7.18265 12.5361'
        stroke={innerColor ? innerColor : 'currentColor'}
        strokeWidth='2'
        strokeLinecap='round'
        fill='none'
      />
    </BaseLibraryIconSvg>
  );
}
